/**
 * @graphql agg
 */
import { graphql } from 'react-relay';

export const ConfluencePricingEndOfTrialPremiumToStandardQuery = graphql`
	query ConfluencePricingEndOfTrialPremiumToStandardQuery($cloudId: ID!, $productKey: String!) {
		tenantContexts(cloudIds: [$cloudId]) {
			entitlementInfo(hamsProductKey: $productKey) {
				entitlement {
					... on CcpEntitlement {
						experienceCapabilities {
							changeOfferingV2(offeringName: "standard") {
								isAvailableToUser
								experienceUrl
							}
						}
						subscription {
							trial {
								endTimestamp
							}
						}
						standardPrice: defaultOfferingTransitions(offeringName: "Standard") {
							listPriceForOrderWithDefaults {
								averageAmountPerUnit
								item {
									chargeElement
								}
							}
						}
						premiumPrice: defaultOfferingTransitions(offeringName: "Premium") {
							listPriceForOrderWithDefaults {
								averageAmountPerUnit
								item {
									chargeElement
								}
							}
						}
					}
				}
			}
		}
	}
`;
